import Vue from 'vue'
import VueRouter from 'vue-router'

import { bus, isString } from './utilities'
import { analytics } from 'shiseido-apis'

import Introduction from './components/introduction.vue'
import Quiz from './components/quiz.vue'
import Results from './components/results.vue'
import '../../scss/giftguide.scss'

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        { path: '/', component: Introduction, name: 'intro' },
        { path: '/giftguide/',      component: Quiz, name: 'who' },
        { path: '/giftguide/:who/', component: Quiz, name: 'category' },
        { path: '/giftguide/:who/:category/', component: Quiz, name: 'price' },
        { path: '/giftguide/:who/:category/:price/', component: Quiz, name: 'lifestyle' },
        { path: '/giftguide/:who/:category/:price/:lifestyle', component: Results, name: 'results' },
        { path: '*', redirect: '/giftguide', name: 'default' }
    ]
})

Vue.filter('capitalize', (str) => str.replace(/(?:^|\s)\S/g, (l) => l.toUpperCase()))
Vue.filter('uppercase',  (str) => str.toUpperCase())
Vue.filter('option_text', (str) => {
    if (!isString(str)) {
        return ''
    }

    return str.replace(/for /i, '')
        .replace(/mens/i, 'men\'s')
        .replace(/sun care/i, 'suncare')
        .replace(/\$100 \+ Over/i, 'over $100')
})
Vue.filter('quiz_option_slug', (value, active_conditional = false) => {
    const slug = isString(value)
        ? value.replace(/\s/g, '_').toLowerCase() : ''

    return slug.concat(active_conditional ? ' active' : '')
})

new Vue({
    router,
    watch: { $route: 'trackPageView' },
    created() {
        bus.$on('next', this.onNext)
    },
    mounted() {
        this.trackPageView()
    },
    methods: {
        onNext: ({ path }) => router.push({ path }),
        trackPageView() {
            analytics.registerPageView({
                toolname: 'Gift Guide',
                pagename: this.$route.name
            })
        }
    }
}).$mount('#composed__shiseido-gift-guide')


// WEBPACK FOOTER //
// ./src/js/app/application-layout.js